<h2 class="alert alert-danger" *ngIf="error">
  {{ error }} Kayıt ve internet durumunuzu kontrol ediniz.
</h2>
<h1>{{ record }}</h1>
<br />
<br />
<button class="excel-button" (click)="exportexcel()">
  Patent Portföy Raporunu İndir (Excel)
</button>
<p></p>
<br />
<input
  *ngIf="visible"
  style="color: #d70040"
  class="form-control"
  class="icon"
  type="text"
  name="search"
  [(ngModel)]="searchText"
  (ngModelChange)="searchText= $event.toLowerCase()"
  autocomplete="off"
  placeholder="Dosya Bilgileri Üzerinden Arama Yapabilirsiniz"
/>
<table id="excel-table" class="tableFixHead">
  <thead>
    <tr>
      <th>#</th>
      <th>Dosya No</th>
      <th>Buluş Adı</th>
      <th>Buluş Bildirim Tarihi</th>
      <th>Buluşun Durumu</th>
      <th>Son Durum Güncellemesi</th>
      <th>Hak Sahipliği Durumu</th>
      <th>Buluş Sahipleri</th>
      <th>Patent Kayıtları</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let user of users1 | filter: searchText; let i = index">
      <ng-container *ngFor="let item of user">
        <ng-container
          *ngIf="
            today - paintRows[i] > oneDay * 5 &&
            (item.status.status == 'Kabul Edilmiş Buluş' ||
              item.status.status == 'Taslak Buluş')
          "
        >
          <td>{{ i + 1 }}</td>
          <td>{{ item.documentNumber }}</td>
          <td>{{ item.inventionName }}</td>
          <td>{{ item.inventionDate | date: "dd/MM/yyyy" }}</td>
          <!-- <td>{{ item.status[item.status.length - 1].status }}</td> -->
          <td>{{ item.status.status }}</td>
          <!-- <td
          [style.background-color]="
            today - paintRows[i] > oneDay * 7 ? 'red' : 'green'
          "
        > -->
          <td
            [style.background-color]="
              today - paintRows[i] > oneDay * 5 &&
              (item.status.status == 'Kabul Edilmiş Buluş' ||
                item.status.status == 'Taslak Buluş')
                ? '#d70040'
                : ''
            "
          >
            {{ item.status.date | DayAgo }}
          </td>
          <!-- [style.background-color]="
            today - paintRows[i] > oneDay / 2 ? 'red' : 'green'
          " -->
          <!-- <button id="remove" class="btn btn-danger" (click)="removeInvention(i)">
          Remove Invention
        </button> -->
          <td>
            <ng-container *ngFor="let subitem of item.CompanyData">
              <hr />
              <ng-container
                >{{ subitem.name | json }}/Katkı Payı:{{ subitem.share | json }}
                <p></p
              ></ng-container>
              <hr />
            </ng-container>
          </td>
          <td>
            <ng-container *ngFor="let subitem of item.inventorData">
              <hr />
              <ng-container
                >{{ subitem.name | json }}/Katkı Payı:{{ subitem.share | json }}
                <p></p
              ></ng-container>
              <hr />
            </ng-container>
          </td>
          <td>
            <ng-container *ngFor="let subitem of item.patentInfo">
              <hr />
              <ng-container
                >Patent Türü:{{ subitem.patentType | json }}/Ülke:{{
                  subitem.patentCountry | json
                }}/Ülkedeki Son Durum:{{
                  subitem.patentStatus.slice(-1)[0].status | json
                }}/Ülke Giriş Tarihi:{{ subitem.patentDate | json }}
                <p></p
              ></ng-container>
              <hr />
            </ng-container>
          </td>
          <td style="background-color: #f8f9fb">
            <button
              id="remove"
              class="btn btn-primary"
              (click)="inventionDetails(i, item.documentNumber)"
            >
              Buluş Detayları
            </button>
          </td>
        </ng-container>
      </ng-container>
    </tr>
  </tbody>
</table>

<br />
<!-- <button class="btn btn-primary" (click)="fetchUsers()">Veriyi Getir</button> -->
<ng-container> </ng-container>
